import { tns } from './../../../node_modules/tiny-slider/src/tiny-slider';

export default class Page {
  constructor() {
    // Page
    this.formLogIn = document.querySelector('aside.popin');

    this.sliderRte();
    this.displayLogin();
    this.closePopin();
  }

  sliderRte() {
    const sliders = document.querySelectorAll('.wp-block-gallery');
    if (sliders.length > 0) {
      sliders.forEach((slider) => {
        let wrapper;
        // if (slider.querySelector('.blocks-gallery-grid')) {
        //   wrapper = slider.querySelector('.blocks-gallery-grid');
        // } else {
        //   wrapper = slider;
        // }
        
        tns({
          container: slider.querySelector('.blocks-gallery-grid'),
          slideBy: 'page',
          autoplay: false,
          loop: false,
          navPosition: 'bottom',
          controlsText: [
            '<span class="sr-only">Précédent</span><svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13"><path d="M14.592,10.158a.605.605,0,0,1,.853,0l2.981,2.991a.6.6,0,0,1,.019.831l-2.937,2.947a.6.6,0,1,1-.853-.85l2.5-2.534-2.559-2.534A.6.6,0,0,1,14.592,10.158Z" transform="translate(-9.508 -7.046)" fill="#D72677"/><path d="M3.375,9.875a6.5,6.5,0,1,0,6.5-6.5A6.5,6.5,0,0,0,3.375,9.875Zm1,0a5.505,5.505,0,1,1,1.613,3.888A5.453,5.453,0,0,1,4.375,9.875Z"transform="translate(-3.375 -3.375)" fill="#D72677"/></svg>',
            '<span class="sr-only">Suivant</span><svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13"><path d="M14.592,10.158a.605.605,0,0,1,.853,0l2.981,2.991a.6.6,0,0,1,.019.831l-2.937,2.947a.6.6,0,1,1-.853-.85l2.5-2.534-2.559-2.534A.6.6,0,0,1,14.592,10.158Z" transform="translate(-9.508 -7.046)" fill="#D72677"/><path d="M3.375,9.875a6.5,6.5,0,1,0,6.5-6.5A6.5,6.5,0,0,0,3.375,9.875Zm1,0a5.505,5.505,0,1,1,1.613,3.888A5.453,5.453,0,0,1,4.375,9.875Z"transform="translate(-3.375 -3.375)" fill="#D72677"/></svg>',
          ],
          autoHeight: true,
        });
      });
    }
  }

  displayLogin() {
    const unlockBtns = document.querySelectorAll(' .locked');
    if (unlockBtns.length > 0) {
      unlockBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          if (this.formLogIn) {
            this.formLogIn.classList.add('open');
          }
        });
      });
    }
  }

  closePopin() {
    if (this.formLogIn) {
      this.formLogIn.querySelector('.overlay').addEventListener('click', () => {
        this.formLogIn.classList.remove('open');
      });
    }
  }
}